import { useMutation, useQuery, useQueryClient } from 'react-query';
import {
    getUserProfile,
    postUserProfile,
    getCurrentOrganization
} from '../../api/users-api';

const key = 'dataUserProfile';

export const useGetUserProfile = () => {
    return useQuery([key], getUserProfile);
};

export const useMutateCurrentOrganization = () => {
    const queryClient = useQueryClient();
    return useMutation(getCurrentOrganization, {
        onSuccess: idOrganization => {
            queryClient.setQueriesData(
                [key],
                previdOrganization => (previdOrganization = idOrganization)
            ); // gurar directamente sin hacer rebalidascion de dato
            queryClient.invalidateQueries([key]);
        }
    });
};

export function useMutateUserProfile() {
    const queryClient = useQueryClient();
    return useMutation(postUserProfile, {
        onSuccess: post => {
            queryClient.setQueriesData([key], prevPost => ({
                ...prevPost,
                ...post
            }));
            queryClient.invalidateQueries([key]);
        }
    });
}
